export default (html: string, urlPrefix: string) => {
    const REGEX = /\B#[a-z_.-]+/gi;
    const hashtags = new Set(html.match(REGEX));
    if (!hashtags.size) {
        return html;
    }

    let output = html;

    hashtags.forEach(hashtag => {
        const hashtagString = hashtag.replace('#', '');
        output = output.replace(new RegExp(hashtag, 'g'), `<a href="${urlPrefix}${hashtagString}">${hashtag}</a>`);
    });

    return output;
};
